import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-menu" }

import { IMenuItem } from '@/@types/config'

import { computed } from 'vue';
import { useConfig } from '@/composables/config';

import '@/components/common/SmMainMenu/style.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmMainMenu',
  setup(__props) {

const { getMainMenu } = useConfig();

const menuList = computed((): IMenuItem[] => getMainMenu());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, i) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `menu-item-${i}`,
        class: "main-menu__item"
      }, [
        _createVNode(_component_router_link, {
          class: "main-menu__link",
          "active-class": "main-menu__link--active",
          to: item.route
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}
}

})